export function getReportStatusNotificationBody(newStatus, reportNumber) {
  const label = reportNumber ? `Zgłoszenie ${reportNumber}` : 'Twoje zgłoszenie';

  switch (newStatus) {
    case 'in_progress':
      return `${label} jest w trakcie realizacji`;
    case 'resolved':
      return `${label} zostało zakończone`;
    case 'rejected':
      return `${label} zostało odrzucone`;
    default:
      return reportNumber
        ? `Status zgłoszenia ${reportNumber} został zmieniony na: ${newStatus}`
        : `Status Twojego zgłoszenia został zmieniony na: ${newStatus}`;
  }
}

export function normalizeStatusNote(note) {
  return typeof note === 'string' ? note.trim() : '';
}

export function appendStatusNote(bodyText, note) {
  const cleanNote = normalizeStatusNote(note);
  if (!cleanNote) return bodyText;
  return `${bodyText}\n\nInformacja: ${cleanNote}`;
}

export function extractStatusNotificationNote(notification) {
  const dataNote = typeof notification?.data?.statusNote === 'string'
    ? notification.data.statusNote.trim()
    : '';
  if (dataNote) return dataNote;

  const body = typeof notification?.body === 'string' ? notification.body : '';
  const marker = 'Informacja:';
  const markerIndex = body.indexOf(marker);
  if (markerIndex === -1) return '';
  return body.slice(markerIndex + marker.length).trim();
}

/**
 * Zawsze zapisuje wpis in-app (dzwoneczek). Expo OS tylko przez EF gdy user ma włączony push.
 * Insert jest niezależny od Edge Function — działa nawet gdy push_enabled = false.
 */
export async function notifyReportStatusChange(supabaseAdmin, {
  userId,
  reportId,
  reportNumber,
  newStatus,
  statusNote,
}) {
  if (!userId || !reportId) {
    return { inserted: false, expoInvoked: false };
  }

  const cleanNote = normalizeStatusNote(statusNote);
  const title = 'Zmiana statusu zgłoszenia';
  const bodyText = appendStatusNote(
    getReportStatusNotificationBody(newStatus, reportNumber),
    cleanNote,
  );
  const data = {
    type: 'report_status_change',
    reportId: String(reportId),
    ...(reportNumber ? { reportNumber: String(reportNumber) } : {}),
    ...(cleanNote ? { statusNote: cleanNote } : {}),
  };

  const { data: inserted, error: insertError } = await supabaseAdmin
    .from('push_notifications')
    .insert({
      user_id: userId,
      title,
      body: bodyText,
      type: 'info',
      data,
      read_at: null,
    })
    .select('id')
    .single();

  if (insertError) {
    console.error('Error persisting in-app status notification:', insertError);
    throw insertError;
  }

  // Expo (opcjonalne) — EF nie robi ponownego insertu
  try {
    const { data: fnData, error: pushError } = await supabaseAdmin.functions.invoke(
      'send-push-notification',
      {
        body: {
          title,
          body: bodyText,
          userId,
          type: 'info',
          skipInsert: true,
          notificationId: inserted?.id,
          data,
        },
      },
    );
    if (pushError) {
      console.error('Error invoking Expo for status notification:', pushError);
    } else if (fnData?.error) {
      console.error('Expo status notification rejected:', fnData.error, fnData.details);
    }
  } catch (expoError) {
    console.error('Error in Expo status notification flow:', expoError);
  }

  return { inserted: true, notificationId: inserted?.id, expoInvoked: true };
}
